export default __webpack_public_path__ + "static/media/owner1-illustration.c9d2d24b.svg";